import React from "react";

import { faUmbrella, faPlusSquare, faEllipsisVertical, faPencil, faTrashCan, faTriangleExclamation, faChevronRight, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import DataTable from 'react-data-table-component';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Spinner from 'react-bootstrap/Spinner';
import ListGroup from "react-bootstrap/ListGroup";
import Modal from 'react-bootstrap/Modal';
import Badge from 'react-bootstrap/Badge';

import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { RiskLevels, ConsequenceLevels, ProbabilityLevels, MitigationStatus } from './RiskLevels'

import ControlDialog from "./ControlDialog";
import MitigationDialog from "./MitigationDialog"; 
import CloseMitigationDialog from "./CloseMitigationDialog"; 

import "./MitigationList.css";

class MitigationList extends React.Component {
	
	state = {	
		isLoading: false,
		isLoadingControls: false,
		isLodaingMitigations:false,
		controlList: [],
		mitigationList: [],
		selectedControl: 0,
		selectedMitigation: { mitigationID:0}
,
		modal: '',
		risk: {
			riskID: 0,
			name: '',
			process: '',
			category: 1,
			owner: 0,
			description: '',
			rootCause: '',
			potentialConsequence: '',
			consequence: 1,
			probability: 1,
			consequenceAfter: 1,
			probabilityAfter: 1
		},
		controlFlags: [],
		mitigationFlags: [],
	};


	componentDidMount() {

	}


	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			if (this.props.risk !== null && this.props.risk !== this.state.risk) {
				this.setState({ risk: this.props.risk });
				if (this.props.risk.riskID !== 0) {
					this.fetchControlList(this.props.risk.riskID);
					this.fetchMitigationList(this.props.risk.riskID);
				}
			}
		}
		if (prevState !== this.state) {
			if (prevState.controlList !== this.state.controlList) {
				this.calculateRiskDev();
			} else if (prevState.mitigationList !== this.state.mitigationList) {
				this.calculateRiskDev();
			}
		}
	}

	fetchControlList(riskID) {
		this.setState({ isLoadingControls: true });
		fetch('api/Mitigation/GetControlList/' + riskID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}				
				this.setState({ controlList: data });
				this.setState({ isLoadingControls: false });			
			})
			.catch(error => {
				this.setState({ isLoadingControls: false });
			})
	}

	fetchMitigationList(riskID) {
		this.setState({ isLoadingMitigations: true });
		fetch('api/Mitigation/GetMitigationList/' + riskID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ mitigationList: data });
				this.setState({ isLoadingMitigations: false });
			})
			.catch(error => {
				this.setState({ isLoadingMitigations: false });
			})
	}

	fetchDeleteControl(id) {
		this.setState({ isLoadingControls: true });
		fetch('api/Mitigation/DeleteControl/' + id, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ isLoadingControls: false });
				this.setState({ modal: '' });
				this.fetchControlList(this.props.risk.riskID);
			})
			.catch(error => {
				this.setState({ isLoadingControls: false });
			})
	}

	fetchDeleteMitigation(id, adjustRisk = false, newRisk = {probability:1, conequence:1}) {
		this.setState({ isLoadingControls: true });
		fetch('api/Mitigation/DeleteMitigation/' + id, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				if (adjustRisk) {
					if (this.props.onAdjustRisk != null) {
						this.props.onAdjustRisk(newRisk);
					}
				}
				this.setState({ isLoadingControls: false });
				this.setState({ modal: '' });
				this.fetchMitigationList(this.props.risk.riskID);
			})
			.catch(error => {
				this.setState({ isLoadingControls: false });
			})
	}

	calculateRiskDev() {
		var warning = false;
		var lowestConsequence = this.state.risk.consequence;
		var lowestProbability = this.state.risk.probability;
		
		if (this.state.controlList && this.state.controlList.length > 0 && this.state.risk.riskID !== 0) {		
			var controlFlags = Array(this.state.controlList.length);
			for (var i = 0; i < this.state.controlList.length; i++) { 
				var control = this.state.controlList[i];
				if (this.state.risk.probability < control.probabilityAfter) {
					controlFlags[i] = { controlID: control.controlID, warning: 'Probability higher after control' };
					warning = true;
				} else if (this.state.risk.consequence < control.consequenceAfter) {
					controlFlags[i] = { controlID: control.controlID, warning: 'Consequence higher after control'	};
					warning = true;
				} else if (this.state.risk.probability * this.state.risk.consequence <= control.probabilityAfter * control.consequenceAfter) {
					controlFlags[i] = { controlID: control.controlID, warning: 'No change in risk after control' };
					warning = true;
				} else {
					controlFlags[i] = { controlID: control.controlID, warning: ''	};
				}
				lowestConsequence = Math.min(lowestConsequence, control.consequenceAfter);
				lowestProbability = Math.min(lowestProbability, control.probabilityAfter);
			}
			this.setState({ controlFlags: controlFlags });		
		}

		if (this.state.mitigationList && this.state.mitigationList.length > 0 && this.state.risk.riskID !== 0) {
			var mitigationFlags = Array(this.state.mitigationList.length);
			for (var i = 0; i < this.state.mitigationList.length; i++) {
				var mitigation = this.state.mitigationList[i];
				if (this.state.risk.probability < mitigation.probabilityAfter) {
					mitigationFlags[i] = { mitigationID: mitigation.mitigationID, warning: 'Probability higher after mitigation' };
					warning = true;
				} else if (this.state.risk.consequence < mitigation.consequenceAfter) {
					mitigationFlags[i] = { mitigationID: mitigation.mitigationID, warning: 'Consequence higher after mitiagtion' };
					warning = true;
				} else if (this.state.risk.probability * this.state.risk.consequence <= mitigation.probabilityAfter * mitigation.consequenceAfter) {
					mitigationFlags[i] = { mitigationID: mitigation.mitigationID, warning: 'No change in risk after mitigation' };
					warning = true;
				} else {
					mitigationFlags[i] = { mitigationID: mitigation.mitigationID, warning: '' };
				}
				lowestConsequence = Math.min(lowestConsequence, mitigation.consequenceAfter);
				lowestProbability = Math.min(lowestProbability, mitigation.probabilityAfter);
			}
			this.setState({ mitigationFlags: mitigationFlags });
		}

		if (this.props.onMitigationChanged != null) {
			this.props.onMitigationChanged({ lowestConsequence, lowestProbability, warning });
		}
	}

	menuPopup(row) {
		return (
			<Popover id="popover-basic" className="popup-menu shadow ">
				<Popover.Body>
					<ListGroup>
						<ListGroup.Item onClick={() => { document.body.click(); this.setState({ selectedControl: row.controlID }); this.setState({ modal: 'control' }) }}>
							<FontAwesomeIcon icon={faPencil} size="sm" /> Edit
						</ListGroup.Item>
						<ListGroup.Item onClick={() => { document.body.click(); this.setState({ selectedControl: row.controlID }); this.setState({ modal: 'archiveControl' }) }}>
							<FontAwesomeIcon icon={faTrashCan} size="sm" /> Archive
						</ListGroup.Item>
					</ListGroup>	
				</Popover.Body>				
			</Popover>
		);
	}

	menuPopupMitigation(row) {
		return (
			<Popover id="popover-basic" className="popup-menu shadow ">
				<Popover.Body>
					<ListGroup>
						<ListGroup.Item onClick={() => { document.body.click(); this.setState({ selectedMitigation: row }); this.setState({ modal: 'mitigation' }) }}>
							<FontAwesomeIcon icon={faPencil} size="sm" /> Edit
						</ListGroup.Item>
						<ListGroup.Item onClick={() => { document.body.click(); this.setState({ selectedMitigation: row }); this.setState({ modal: 'archiveMitigation' }) }}>
							<FontAwesomeIcon icon={faTrashCan} size="sm" /> Archive
						</ListGroup.Item>
					</ListGroup>
				</Popover.Body>
			</Popover>
		);
	}

	customLoader() {
		return (
			<div style={{ padding: '24px' }}>
				<Spinner animation="border" />
				<div>Loading...</div>
			</div>
		);
	}

	handleCloseControlDialog(isChanged) {
		this.setState({ selectedControl: 0 });
		this.setState({ modal: '' });
		if (isChanged) {
			this.fetchControlList(this.state.risk.riskID);
		}		
	}

	handleCloseMitigationDialog(isChanged) {
		this.setState({ selectedMitigation: { mitigationID: 0 } });
		this.setState({ modal: '' });
		if (isChanged) {
			this.fetchMitigationList(this.state.risk.riskID);
		}
	}

	handleCloseArchiveMitigationDialog(isArchived, adjustRisk = false) {

		if (isArchived) {
			this.fetchDeleteMitigation(this.state.selectedMitigation.mitigationID, adjustRisk, { probability: this.state.selectedMitigation.probabilityAfter, consequence: this.state.selectedMitigation.consequenceAfter });
		}
		this.setState({ selectedMitigation: { mitigationID: 0 } });		
		this.setState({ modal: '' });
	}

	activateNewControlModal() {
		this.setState({ selectedControl: 0 });
		this.setState({ modal: 'control' });
	}

	activateNewMitigationModal() {
		this.setState({ selectedMitigation: { mitigationID: 0 } });
		this.setState({ modal: 'mitigation' });
	}

	archiveControl() {
		this.fetchDeleteControl(this.state.selectedControl) 
		//this.setState({ modal: '' });
	}

	riskTemplate(rowData, index) {
		const text = RiskLevels[rowData.consequenceAfter - 1][rowData.probabilityAfter - 1].label;
		const riskBgColor = RiskLevels[rowData.consequenceAfter - 1][rowData.probabilityAfter - 1].bgColor;
		const riskColor = RiskLevels[rowData.consequenceAfter - 1][rowData.probabilityAfter - 1].color;
		const style = { backgroundColor: riskBgColor, color: riskColor, width: "100%" };

		const controlFlag = this.state.controlFlags.find(control => control.controlID === rowData.controlID);
		
		return (
			<div style={{ whiteSpace: 'nowrap' }}><Badge style={style} bg="" > {text}</ Badge> {controlFlag && controlFlag.warning !== '' ? < Badge pill bg="warning" text="dark">!</Badge> : null}</div>
		);
	}

	mitigationRiskTemplate(rowData, index) {
		const text = RiskLevels[rowData.consequenceAfter - 1][rowData.probabilityAfter - 1].label;
		const riskBgColor = RiskLevels[rowData.consequenceAfter - 1][rowData.probabilityAfter - 1].bgColor;
		const riskColor = RiskLevels[rowData.consequenceAfter - 1][rowData.probabilityAfter - 1].color;
		const style = { backgroundColor: riskBgColor, color: riskColor, width: "100%" };

		const mitigationFlag = this.state.mitigationFlags.find(mitigation => mitigation.mitigationID === rowData.mitigationID);

		return (
			<div style={{ whiteSpace: 'nowrap' }}><Badge style={style} bg="" > {text}</ Badge> {mitigationFlag && mitigationFlag.warning !== '' ? < Badge pill bg="warning" text="dark">!</Badge> : null}</div>
		);
	} 

	mitigationStatusTemplate(rowData, index) {
		const status = MitigationStatus.find((item) => item.id === rowData.status );

		return (
			<div className="flex align-items-center">
				<Badge style={{ backgroundColor: status.color }} bg="" pill>&nbsp;&nbsp;</ Badge>&nbsp;
				<div>{status.name}</div>
			</div>
		);
	} 
	
	render() {
		const filteredData = this.state.controlList;
		const filteredDataMitigations = this.state.mitigationList;

		const customStyles = {
			headRow: {
				style: {
					border: 'none',
				},
			},
			headCells: {
				style: {
					color: '#202124',
					fontSize: '14px',
				},
			},
			rows: {
				highlightOnHoverStyle: {
					backgroundColor: 'AliceBlue',
					borderBottomColor: '#FFFFFF',
					borderRadius: '25px',
					outline: '1px solid #FFFFFF',
				},
			},
		};

		const columns = [
			{
				cell: (row) => <FontAwesomeIcon icon={faUmbrella} style={{ backgroundColor: 'gray', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />,
				width: '2.75rem', // custom width for icon button
				style: {
					borderBottom: '1px solid #FFFFFF',
					marginBottom: '-1px',
				},
			},
			{
				name: 'Control name',
				selector: row => row.name,
				sortable: true,
				grow: 2,
				style: {
					color: '#202124',
					fontSize: '14px',
					fontWeight: 500,
				},
			},
			{
				name: 'Risk after',
				selector: row => row.consequenceAfter * row.probabilityAfter,
				cell: (row, index) => this.riskTemplate(row, index),
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Modified',
				selector: row => row.changeDate.split('T')[0],
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				cell: row => <OverlayTrigger trigger="click" placement="left" rootClose overlay={this.menuPopup(row)}>
					<Button variant="light" className="btn-circle"><FontAwesomeIcon icon={faEllipsisVertical} /></Button>
				</OverlayTrigger>,
				allowOverflow: true,
				button: true,
				width: '3rem',
			},
		];


		const mitigationColumns = [
			{
				cell: (row) => <FontAwesomeIcon icon={faUmbrella} style={{ backgroundColor: 'gray', color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />,
				width: '2.75rem', // custom width for icon button
				style: {
					borderBottom: '1px solid #FFFFFF',
					marginBottom: '-1px',
				},
			},
			{
				name: 'Control name',
				selector: row => row.name,
				sortable: true,
				grow: 2,
				style: {
					color: '#202124',
					fontSize: '14px',
					fontWeight: 500,
				},
			},
			{
				name: 'Status',
				selector: row => row.status,
				cell: (row, index) => this.mitigationStatusTemplate(row, index),
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Deadline',
				selector: row => row.deadline.split('T')[0],
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Risk after',
				selector: row => row.consequenceAfter * row.probabilityAfter,
				cell: (row, index) => this.mitigationRiskTemplate(row, index),
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Modified',
				selector: row => row.changeDate.split('T')[0],
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				cell: row => <OverlayTrigger trigger="click" placement="left" rootClose overlay={this.menuPopupMitigation(row)}>
					<Button variant="light" className="btn-circle"><FontAwesomeIcon icon={faEllipsisVertical} /></Button>
				</OverlayTrigger>,
				allowOverflow: true,
				button: true,
				width: '3rem',
			},
		];

		return (	
			<div>
				<ConfirmDialog />
				<Modal size="lg" centered show={this.state.modal === 'archiveControl'}>
					<Modal.Header closeButton={false}>
						<Modal.Title >
							Archive Control
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>
							Do you really want to archive the control?
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="primary" onClick={this.archiveControl.bind(this)}>Archive</Button>
						<Button variant="secondary" onClick={() => { this.setState({ modal: '' }); }} >Cancel</Button>
					</Modal.Footer>
				</Modal>

				<ControlDialog visible={this.state.modal === 'control'} onClose={this.handleCloseControlDialog.bind(this)} risk={this.state.risk ? this.state.risk : {} } controlID={this.state.selectedControl} /> 
				<MitigationDialog visible={this.state.modal === 'mitigation'} onClose={this.handleCloseMitigationDialog.bind(this)} risk={this.state.risk ? this.state.risk : {}} mitigationID={this.state.selectedMitigation.mitigationID} />
				<CloseMitigationDialog visible={this.state.modal === 'archiveMitigation'} onClose={this.handleCloseArchiveMitigationDialog.bind(this)} risk={this.state.risk ? this.state.risk : {}} mitigation={this.state.selectedMitigation} risk={this.state.risk ? this.state.risk : {}} /> 
	

				<Card className="workspace-card">
					<Card.Header>
						<div style={{ float: 'left' }}>
							<b>Controls</b>
						</div>
						<div style={{ float: 'right' }}>
							<Button size='sm' onClick={() => { this.activateNewControlModal() }} id={"btn_add"} variant="primary" disabled={false}><FontAwesomeIcon icon={faPlusSquare} /> New </Button>
						</div>
					</Card.Header>
					<Card.Body>
						<DataTable
							responsive
							className="data-table"
							columns={columns}
							data={filteredData}
							customStyles={customStyles}
							progressPending={this.state.isLoadingControls}
							progressComponent={this.customLoader()}
							highlightOnHover
							pointerOnHover
							noHeader={true}
							onRowClicked={(row, event) => { this.setState({ selectedControl: row.controlID }); this.setState({ modal: 'control' }) }}
							/>
					</Card.Body>

				</Card>
				<Card className="workspace-card">
					
					<Card.Header>
						<div style={{ float: 'left' }}>
							<b>Mitigations</b>
						</div>
						<div style={{ float: 'right' }}>
							<Button size='sm' onClick={() => { this.activateNewMitigationModal() }} id={"btn_add"} variant="primary" disabled={false}><FontAwesomeIcon icon={faPlusSquare} /> New </Button>
						</div>
					</Card.Header>
					<Card.Body>
						<DataTable
							responsive
							className="data-table"
							columns={mitigationColumns}
							data={filteredDataMitigations}
							customStyles={customStyles}
							progressPending={this.state.isLoadingMitigations}
							progressComponent={this.customLoader()}
							highlightOnHover
							pointerOnHover
							noHeader={true}
							onRowClicked={(row, event) => { this.setState({ selectedMitigation: row }); this.setState({ modal: 'mitigation' }) }}
						/>
					</Card.Body>

				</Card>
			</div>
		)
	}
}
export default MitigationList;

